import { render, staticRenderFns } from "./ticketsMutiPackgae.vue?vue&type=template&id=144cb857&"
import script from "./ticketsMutiPackgae.vue?vue&type=script&lang=js&"
export * from "./ticketsMutiPackgae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports